import { USER_ROLES } from '../../auth/index';

const PERMISSIONS = [
	USER_ROLES.CSM,
	USER_ROLES.IMPLEMENTATION,
	USER_ROLES.LANGOS_APP,
	USER_ROLES.OPS,
	USER_ROLES.OWNER,
	USER_ROLES.LANGOPS,
	USER_ROLES.ADMIN,
];

export default {
	REPORTING: {
		ACTIVE: true,
		NAME: 'manage-reporting',
		LABEL: 'Reports',
		ICON: 'content-file-text',
		PATH: '/reports/:section',
		CHILDREN: ['REPORTING_USAGE', 'AGENTS_REPORTING', 'QUALITY_REPORTING'],
		PERMISSIONS,
	},

	REPORTING_USAGE: {
		ACTIVE: true,
		NAME: 'manage-reporting-home',
		LABEL: 'Usage',
		PATH: '/reports/usage',
		PARAMS: {
			section: 'usage',
		},
		PERMISSIONS,
	},
	REPORTING_SUMMARY: {
		ACTIVE: false,
		NAME: 'manage-reporting-summary',
		LABEL: 'Summary',
		PATH: '/reports/summary',
		PARAMS: {
			section: 'summary',
		},
		PERMISSIONS,
	},
	REPORTING_COST: {
		ACTIVE: false,
		NAME: 'manage-reporting-cost',
		LABEL: 'Cost',
		PATH: '/reports/cost',
		PARAMS: {
			section: 'cost',
		},
		PERMISSIONS,
	},
	QUALITY_REPORTING: {
		ACTIVE: false,
		NAME: 'manage-quality-reporting',
		LABEL: 'Quality',
		PATH: '/reports/quality',
		PARAMS: {
			section: 'quality',
		},
		PERMISSIONS,
	},
	QUALITY_REPORTING_TICKETS: {
		ACTIVE: false,
		NAME: 'quality-reporting-tickets',
		LABEL: 'Tickets',
		PATH: '/reports/quality/ticket',
		PERMISSIONS,
	},
	QUALITY_REPORTING_CHAT: {
		ACTIVE: false,
		NAME: 'quality-reporting-chat',
		LABEL: 'Chat',
		PATH: '/reports/quality/chat',
		PARAMS: {
			section: 'chat',
		},
		PERMISSIONS,
	},
	QUALITY_REPORTING_FAQS: {
		ACTIVE: false,
		NAME: 'quality-reporting-faqs',
		LABEL: 'FAQs',
		PATH: '/reports/quality/faqs',
		PARAMS: {
			section: 'faqs',
		},
		PERMISSIONS,
	},
	AGENTS_REPORTING: {
		ACTIVE: true,
		NAME: 'manage-agents-reporting-home',
		LABEL: 'Agents',
		PATH: '/reports/agents',
		PARAMS: {
			section: 'agents',
		},
		PERMISSIONS,
	},

	AGENTS_REPORTING_AGENT: {
		ACTIVE: true,
		NAME: 'agents-reporting-agent',
		LABEL: 'Agent Report',
		PATH: '/reports/agents/:id',
		PARAMS: {
			section: ':id',
		},
		PERMISSIONS,
	},
};
